<script>
    import { Effects } from "../stores/effectsStore";

    export let filter;
    export let onSelect;
    export let effectsVisible;
    export let mwOn;
    export let trOn;
    export let bmOn;

    let value = "";
    $: effects = Effects.find(value, { effectsVisible, mwOn, trOn, bmOn }).filter(filter);

    let showSuggestions = false;
    const clear = () => value = "";
    const close = () => showSuggestions = false;
    const open = () => showSuggestions = true;
</script>

<svelte:window on:click={close} />

<div class="effects" on:click|stopPropagation>
    <input 
        bind:value 
        on:click|stopPropagation
        on:focus={open}
        placeholder="Find effect"
    />
    {#if showSuggestions}
        <div class="suggestions">
            {#each effects as effect}
                <div class="effect" 
                    on:click={() => {
                        onSelect(effect);
                        close();
                        clear();
                    }
                }>
                    <img src={`/images/effects/${effect.replaceAll(" ", "_")}.jpg`} alt="glyph" />
                    <span class="effect-name">{effect}</span>
                </div>
            {/each}
            {#if !effects.length}
                <div class="effect-name">Nothing found</div>
            {/if}
        </div>
    {/if}
</div>

<style>
    .suggestions {
        position: absolute;
        top: calc(100% - 1px);
        left: 0;

        width: 100%;
        
        background-color: #060503;

        border: 1px solid #D8C187;
        border-radius: 4px;

        max-height: 600px;
        overflow: auto;

        padding: 2px 0 0 0;
    }

    .effects {
        position: relative;

        width: 250px;
        height: fit-content;

        display: flex;
        flex-direction: column;
    }
    .effect {
        display: flex;
        align-items: center;
        cursor: pointer;
        line-height: 24px;
        border-radius: 4px;

        padding: 3px;
    }
    .effect-name {
        margin-left: 8px;
        padding-top: 3px;
    }
    .effect:hover {
        background-color: #2f304fcc;
    }
</style>